module.exports = __webpack_public_path__ + "static/media/20ECE10.50b36295.jpg";